import {
  DataEntryAccidentStepSectionProps,
  typedMemo,
  YesNoAnswer,
} from "src/types";
import { FormRow, InputGroup, InputText } from "src/ui/widgets";
import { useDataEntryAccidentStepMaterialDamages } from "./accident-step-material-damages.hook";
import { ChangeEvent } from "react";
import { TEXTAREA_MAX_LENGTH } from "src/config";

export const DataEntryAccidentStepMaterialDamages = typedMemo(
  (props: DataEntryAccidentStepSectionProps) => {
    const {
      formikAccidentValues,
      formikAccidentErrors,
      formikAccidentTouched,
      formik,
      validationSchema,
    } = props;
    const { handleChange, handleBlur } = formik;

    const {
      yesNoOptions,
      t,
      onSelectOtherVehiclesDamagedQuestion,
      onSelectOtherObjectsDamagedQuestion,
    } = useDataEntryAccidentStepMaterialDamages(props);

    return (
      <>
        <FormRow
          firstField={
            <InputGroup
              style="radio"
              name="accidentData.materialDamages.otherVehiclesDamaged"
              handleChange={(event: ChangeEvent<HTMLInputElement>) => {
                onSelectOtherVehiclesDamagedQuestion(event);
                handleChange(event);
              }}
              handleBlur={handleBlur}
              options={yesNoOptions}
              validationSchema={validationSchema}
              touched={
                formikAccidentTouched?.materialDamages?.otherVehiclesDamaged
              }
              value={formikAccidentValues.materialDamages?.otherVehiclesDamaged}
              error={
                formikAccidentErrors?.materialDamages?.otherVehiclesDamaged
              }
              label={t(
                "data_entry.accident_step.section_material_damages_other_vehicles_question"
              )}
              classes="m-0 ps-0"
              classesLabel="m-0 p-0 d-flex align-items-center mb-3"
            />
          }
        />
        {formikAccidentValues.materialDamages?.otherVehiclesDamaged ===
          YesNoAnswer.YES && (
          <FormRow
            full_row
            firstField={
              <InputText
                name="accidentData.materialDamages.otherVehiclesDamageDetails"
                textarea
                maxLength={TEXTAREA_MAX_LENGTH}
                handleChange={handleChange}
                handleBlur={handleBlur}
                validationSchema={validationSchema}
                touched={
                  formikAccidentTouched?.materialDamages
                    ?.otherVehiclesDamageDetails
                }
                value={
                  formikAccidentValues.materialDamages
                    ?.otherVehiclesDamageDetails
                }
                error={
                  formikAccidentErrors?.materialDamages
                    ?.otherVehiclesDamageDetails
                }
                label={t(
                  "data_entry.accident_step.section_material_damages_other_vehicles_details"
                )}
                placeholder={t("commons.insert")}
              />
            }
          />
        )}

        <FormRow
          firstField={
            <InputGroup
              style="radio"
              name="accidentData.materialDamages.otherObjectsDamaged"
              handleChange={(event: ChangeEvent<HTMLInputElement>) => {
                onSelectOtherObjectsDamagedQuestion(event);
                handleChange(event);
              }}
              handleBlur={handleBlur}
              options={yesNoOptions}
              validationSchema={validationSchema}
              touched={
                formikAccidentTouched?.materialDamages?.otherObjectsDamaged
              }
              value={formikAccidentValues.materialDamages?.otherObjectsDamaged}
              error={formikAccidentErrors?.materialDamages?.otherObjectsDamaged}
              label={t(
                "data_entry.accident_step.section_material_damages_other_objects_question"
              )}
              classes="m-0 ps-0"
              classesLabel="m-0 p-0 d-flex align-items-center mb-3"
            />
          }
        />
        {formikAccidentValues.materialDamages?.otherObjectsDamaged ===
          YesNoAnswer.YES && (
          <FormRow
            full_row
            firstField={
              <InputText
                name="accidentData.materialDamages.otherObjectsDamageDetails"
                textarea
                maxLength={TEXTAREA_MAX_LENGTH}
                handleChange={handleChange}
                handleBlur={handleBlur}
                validationSchema={validationSchema}
                touched={
                  formikAccidentTouched?.materialDamages
                    ?.otherObjectsDamageDetails
                }
                value={
                  formikAccidentValues.materialDamages
                    ?.otherObjectsDamageDetails
                }
                error={
                  formikAccidentErrors?.materialDamages
                    ?.otherObjectsDamageDetails
                }
                label={t(
                  "data_entry.accident_step.section_material_damages_other_objects_details"
                )}
                placeholder={t("commons.insert")}
              />
            }
          />
        )}
      </>
    );
  }
);
